module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Italic.eot?2b90cfc3dc9518e43ccb2e23246282f6";